import React, { useState } from 'react';
import { Mail, Phone, MapPin, Copy } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { companyInfo } from '../mockData';

const Contact = () => {
  const quoteTemplate = `Full Name:
Email Address:
Phone Number:
Company Name:
Sample Name / Sample ID:
Material Type:
Temperature (°C):
Duration (seconds):
Project Details:`;

  const handleCopyTemplate = () => {
    const textarea = document.getElementById('quoteTemplate');
    if (textarea) {
      textarea.select();
      try {
        document.execCommand('copy');
        alert('Template copied. Please paste into your email.');
      } catch (err) {
        alert('Please manually select and copy the template.');
      }
    }
  };

  return (
    <section id="contact" className="py-16 bg-[#f9fbfd]">
      <div className="max-w-4xl mx-auto px-5 text-center">
        
        {/* Header */}
        <h2 className="text-4xl font-bold text-gray-900 mb-3">Request a Quote</h2>
        <p className="text-base text-gray-600 mb-8">
          Copy the template below, fill in your details, and email it to:<br />
          <a 
            href={`mailto:${companyInfo.email}`}
            className="font-bold text-[#1a8f5b] hover:text-green-700 text-lg inline-block whitespace-nowrap"
          >
            {companyInfo.email}
          </a>
        </p>

        {/* Template Box */}
        <div className="bg-white rounded-xl p-6 text-left shadow-lg mb-12">
          <textarea
            id="quoteTemplate"
            readOnly
            value={quoteTemplate}
            className="w-full h-60 border-none resize-none text-base leading-relaxed focus:outline-none"
            style={{ fontFamily: 'monospace' }}
          />
          
          <button
            onClick={handleCopyTemplate}
            className="mt-4 px-5 py-2.5 border-none rounded-lg bg-[#1a8f5b] text-white text-sm cursor-pointer hover:bg-green-700 transition-colors"
          >
            Copy Template
          </button>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <Card className="border-2 hover:border-green-600 transition-all">
            <CardContent className="pt-6 text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <Mail className="w-6 h-6 text-green-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-1">Email</div>
              <a 
                href={`mailto:${companyInfo.email}`} 
                className="text-xs text-green-600 hover:text-green-700 block break-words px-2"
              >
                {companyInfo.email}
              </a>
            </CardContent>
          </Card>

          <Card className="border-2 hover:border-blue-600 transition-all">
            <CardContent className="pt-6 text-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <Phone className="w-6 h-6 text-blue-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-1">Phone</div>
              <a 
                href={`tel:${companyInfo.phone}`} 
                className="text-sm text-blue-600 hover:text-blue-700"
              >
                {companyInfo.phone}
              </a>
            </CardContent>
          </Card>

          <Card className="border-2 hover:border-purple-600 transition-all">
            <CardContent className="pt-6 text-center">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <MapPin className="w-6 h-6 text-purple-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-1">Location</div>
              <div className="text-sm text-gray-600">{companyInfo.address}</div>
            </CardContent>
          </Card>
        </div>

      </div>
    </section>
  );
};

export default Contact;
